import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage.js";
import VeiculoClient from "./pages/Veiculo.js";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade.js";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade/>}/>
          <Route path="/veiculo/:idVeiculo" element={<VeiculoClient />}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;